import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "19",
  viewBox: "0 0 21 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8.9117",
      cy: "8.1617",
      r: "7.1617",
      stroke: "black",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("line", {
      x1: "15.0235",
      y1: "12.8593",
      x2: "19.9568",
      y2: "17.7926",
      stroke: "black",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}
export default { render: render }